import { PortalSelectedLoan } from '../../App';
import { getLoanOfficerContact } from '../../utils/loanOfficer';
import { ContactForm } from '../contact-form/ContactForm';
import { ManageLoanHeader } from './Header';

interface Props {
  loan: PortalSelectedLoan;
}

export const ManageLoanContact = ({ loan }: Props) => {
  const { name, supportPhone, supportEmail, supportHours, portalSettings } = loan.company;
  const loanOfficer = portalSettings.loanDetails.loanOfficer ? getLoanOfficerContact(loan.currentSnapshot) : undefined;

  return (
    <>
      <ManageLoanHeader
        title={`Contact ${name}`}
        subtitle={`Contact ${name} directly with any requests or questions.`}
      />

      <ContactForm
        phone={supportPhone}
        email={supportEmail}
        hours={supportHours ?? undefined}
        loanOfficer={loanOfficer}
      />
    </>
  );
};
